// extracted by mini-css-extract-plugin
export var checkmark = "styles-module__checkmark___ANUxm";
export var verified = "styles-module__verified___znegh";
export var unverified = "styles-module__unverified___u1PmD";
export var shortened = "styles-module__shortened___jjM0e";